import { NgModule } from '@angular/core';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { USER_ACCOUNT_FEATURE, UserAccountRootModule } from '@spartacus/user/account/root';
import { USER_PROFILE_FEATURE, UserProfileRootModule } from '@spartacus/user/profile/root';

@NgModule({
  declarations: [],
  imports: [UserAccountRootModule, UserProfileRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [USER_ACCOUNT_FEATURE]: {
          module: () => import('@spartacus/user/account').then((m) => m.UserAccountModule),
        },
      },
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        [USER_PROFILE_FEATURE]: {
          module: () => import('@spartacus/user/profile').then((m) => m.UserProfileModule),
        },
      },
    }),
  ],
})
export class UserFeatureModule {}
